import { IconMap16, UIText2 } from '@cian/ui-kit';

import { type FC } from 'react';

import styles from './ListingViewModeSwitcher.css';

interface IListingViewModeSwitcherProps {
  onSwitch: VoidFunction;
}

export const ListingViewModeSwitcher: FC<IListingViewModeSwitcherProps> = ({ onSwitch }) => {
  return (
    <div
      className={styles['listing-view-mode-switcher']}
      data-testid="listing.viewModeSwitcher"
      role="button"
      onClick={onSwitch}
    >
      <div className={styles['button']}>
        <IconMap16 color="primary_100" />
        <UIText2 color="primary_100" fontWeight="bold">
          Показать на карте
        </UIText2>
      </div>
    </div>
  );
};
